import type { FieldOption } from '../types';
import { normalizeValue } from './normalizeValue';

export function findInOptions(
  value: string | number,
  options: FieldOption[] = []
) {
  return options.find(
    ({ id, name, value: optionValue }) =>
      value === id ||
      normalizeValue(value) === normalizeValue(name) ||
      value === optionValue
  );
}
